import { IStyle } from '@fluentui/react';

export interface IEScorerDataDisplayStyles {
  chartWrapper?: IStyle;
}

export const eScorerDataDisplayStylesDefault = (): Partial<IEScorerDataDisplayStyles> => ({
  chartWrapper: {
    margin: '1rem auto 2rem auto',
  },
});
